import { Observable } from 'rxjs/internal/Observable';
import { RestResponse } from '../entities/rest.response-generic.model';

export class ApiCallsHelper {
    /**
     * Turns a rxjs observable into a promise and returns the result. If the response
     * code is not 0, the promise will be rejected with response message as error.
     */
    public static async toPromise<T>(
        observable: Observable<RestResponse<T>>
    ): Promise<T> {
        const res = await observable.toPromise();

        if (res.code === 0) {
            return res.result;
        } else {
            throw new Error(res.message ?? res.toString());
        }
    }
}
